import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { LoadingController } from '../utils/LoadingController';
import { refreshToken, returnToSignin } from '../utils/nav';

let refreshTokenTimeout: NodeJS.Timeout | undefined = undefined;

const timeoutDuration = 15000; //15 seconds

export const startRefreshTokenTimeout = () => {
  LoadingController.forceShow();

  refreshTokenTimeout = setTimeout(() => {
    LoadingController.forceHide();
    //Go to login page
    returnToSignin();
  }, timeoutDuration);

  refreshToken();
};

export const stopRefreshTokenTimeout = () => {
  if (refreshTokenTimeout) {
    clearTimeout(refreshTokenTimeout);
  }
};

type RequestOptions = AxiosRequestConfig;

const handleRequests = <T = any>({
  method,
  url,
  headers,
  data,
  params,
}: RequestOptions): Promise<AxiosResponse<T>> =>
  new Promise((res, rej) => {
    axios<T>({
      url,
      method,
      headers,
      data,
      params,
    })
      .then((response) => res(response))
      .catch((error: AxiosError) => {
        if (error.status === 401 && !LoadingController.isForcedLoading()) {
          startRefreshTokenTimeout();
        }
        rej(error);
      });
  });

export default handleRequests;
